<script>

    import {onMount} from "svelte";
    import gsap from "gsap";
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

    import {labels, mainTimeline} from "../../timelines/main-timeline";

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    gsap.registerPlugin(DrawSVGPlugin);
    const {buildingStart, buildingEnd} = labels;

    onMount(() => {

        inTimeline
            .from('.all-building-shapes', {
                opacity: 0,
                duration: 0.1,
            })
            .from('.rectBuilding', {
                scaleY: 0,
                duration: 0.5,
                transformOrigin: 'bottom'
            }, '<')
            .from('.lineBuilding', {
                drawSVG: 0,
                duration: 0.5,
                stagger: 0.1,
            })
            .from('.pathBuilding', {
                drawSVG: 0,
                duration: 0.65,
                stagger: 0.025,
            })
            ;

        outTimeline
            .to('.all-building-shapes', {
                scale: 0,
                duration: 1,
                transformOrigin: 'center',
            })
            .to('.all-building-shapes', {
                opacity: 0, duration: 0.5
            }, '<+=0.5')

        mainTimeline.add(inTimeline, buildingStart);
        mainTimeline.add(outTimeline, buildingEnd);
    });

</script>

<style>
    .building1, .building2 {
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
    }

    .building1 {
        stroke: #96cc28;
    }

    .building2 {
        stroke: #fff;
    }
</style>

<svg id="building" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 319.6 535.42" width="400px" x="760" y="200">
    <g class="all-building-shapes">
        <g>
            <rect class="building2 rectBuilding" x="45.6" y="51.6" width="221.36" height="482.82"/>
            <line class="building2 lineBuilding" x1="45.94" y1="133.4" x2="266.96" y2="133.4"/>
            <line class="building2 lineBuilding" x1="45.94" y1="213.6" x2="266.96" y2="213.6"/>
            <line class="building2 lineBuilding" x1="45.6" y1="293.81" x2="266.96" y2="293.81"/>
            <line class="building2 lineBuilding" x1="45.6" y1="374.01" x2="266.96" y2="374.01"/>
            <line class="building2 lineBuilding" x1="45.6" y1="464.24" x2="266.96" y2="464.24"/>
            <g>
                <line class="building2 lineBuilding" x1="115.37" y1="53.2" x2="115.37" y2="464.24"/>
                <line class="building2 lineBuilding" x1="195.57" y1="53.2" x2="195.46" y2="464.24"/>
                <line class="building2 lineBuilding" x1="234.07" y1="53.2" x2="234.07" y2="464.24"/>
                <line class="building2 lineBuilding" x1="152.27" y1="53.2" x2="152.27" y2="464.24"/>
                <line class="building2 lineBuilding" x1="78.48" y1="53.2" x2="78.48" y2="464.24"/>
            </g>
            <rect class="building2 rectBuilding" x="116.23" y="497.52" width="80.09" height="36.89"/>
            <line class="building2 lineBuilding" x1="156.28" y1="498.12" x2="156.28" y2="534.22"/>
        </g>
        <g>
            <g>
                <path class="building1 pathBuilding"
                      d="M267.98,511.56h0c14.62,0,26.47-16.76,26.47-31.38h0c0-30.38-18.59-46.42-41.51-46.42H126.87c-17.96,0-32.53-14.56-32.53-32.53v-11.09"/>
                <g>
                    <path class="building1 pathBuilding"
                          d="M162.02,432.71v-3.61c-.19-13.56-10.31-24.46-23.88-24.46h0v6.92c0,12.12,11.75,21.95,23.88,21.95"/>
                    <path class="building1 pathBuilding"
                          d="M209.04,432.95c-5,0-10.03-1.76-13.99-4.8-3.82-2.92-7.08-8.17-7.08-13.13v-5.86c11.5,0,20.86,9.23,21.02,20.73l.04,3.06"/>
                    <path class="building1 pathBuilding"
                          d="M257.47,432.95c-5,0-10.03-1.76-13.99-4.8-3.82-2.92-7.08-8.17-7.08-13.13v-5.86c11.5,0,20.86,9.23,21.02,20.73l.04,3.06"/>
                    <path class="building1 pathBuilding"
                          d="M183.93,434.57c-11.93,0-19.36,6.02-19.36,16.77v5.42h0c10.63,0,19.28-8.53,19.43-19.16l-.08-3.03"/>
                    <path class="building1 pathBuilding"
                          d="M232.36,434.57c-11.93,0-19.36,6.02-19.36,16.77v5.42h0c10.63,0,19.28-8.53,19.43-19.16l-.08-3.03"/>
                </g>
            </g>
            <g>
                <path class="building1 pathBuilding"
                      d="M205.17,20.36c0-11.93,6.02-19.36,16.77-19.36h5.42c0,10.63-8.53,19.28-19.16,19.43l-3.03-.08"/>
                <g>
                    <path class="building1 pathBuilding"
                          d="M44.09,233.65h0c-14.62,0-26.47-16.76-26.47-31.38h0c0-30.38,18.59-46.42,41.51-46.42h119.98c17.96,0,32.53-14.56,32.53-32.53v-29.03c0-7.31-5.92-13.23-13.23-13.23h-1.2c-7.31,0-13.23,5.92-13.23,13.23h0c0,7.31,5.92,13.23,13.23,13.23h6.68c13.59,0,24.6-11.01,24.6-24.6V44.22c0-12.87-10.43-23.3-23.3-23.3h-9.18c-11.96,0-21.66,9.7-21.66,21.66v8.42"/>
                    <g>
                        <path class="building1 pathBuilding"
                              d="M150.05,154.81v-3.61c.19-13.56,10.31-24.46,23.88-24.46h0v6.92c0,12.12-11.75,21.95-23.88,21.95"/>
                        <path class="building1 pathBuilding"
                              d="M103.03,155.04c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
                        <path class="building1 pathBuilding"
                              d="M54.6,155.04c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
                        <path class="building1 pathBuilding"
                              d="M128.13,156.67c11.93,0,19.36,6.02,19.36,16.77v5.42h0c-10.63,0-19.28-8.53-19.43-19.16l.08-3.03"/>
                        <path class="building1 pathBuilding"
                              d="M79.71,156.67c11.93,0,19.36,6.02,19.36,16.77v5.42h0c-10.63,0-19.28-8.53-19.43-19.16l.08-3.03"/>
                    </g>
                </g>
                <path class="building1 pathBuilding"
                      d="M36.1,162.42c0-5-1.68-9.82-4.72-13.78-2.92-3.82-8.17-7.08-13.13-7.08h-5.86c0,11.5,9.23,20.86,20.73,21.02l2.98-.16"/>
            </g>
            <g>
                <g>
                    <g>
                        <g>
                            <path class="building1 pathBuilding"
                                  d="M90.65,177.31v61.36c0,17.16-13.9,31.07-31.06,31.07h-10.4c-13.38,0-24.22,10.84-24.22,24.22v31.12c0,11.96,7.29,21.65,19.25,21.65"/>
                            <path class="building1 pathBuilding"
                                  d="M91.44,39.57l3.61-.05c13.56-.19,24.46-11.25,24.46-24.81h-6.92c-12.12,0-21.95,9.83-21.95,21.95v118.4"/>
                        </g>
                        <path class="building1 pathBuilding"
                              d="M91.21,91.65c0-5,1.76-10.03,4.8-13.99,2.92-3.82,8.17-7.08,13.13-7.08h5.86c0,11.5-9.23,20.86-20.73,21.02l-3.06,.04"/>
                        <path class="building1 pathBuilding"
                              d="M91.21,206.34c0-5,1.76-10.03,4.8-13.99,2.92-3.82,8.17-7.08,13.13-7.08h5.86c0,11.5-9.23,20.86-20.73,21.02l-3.06,.04"/>
                        <path class="building1 pathBuilding"
                              d="M89.58,65.21c0-11.93-6.02-19.36-16.77-19.36h-5.42c0,10.63,8.53,19.28,19.16,19.43l3.03-.08"/>
                        <path class="building1 pathBuilding"
                              d="M89.58,123.76c0-11.93-6.02-19.36-16.77-19.36h-5.42c0,10.63,8.53,19.28,19.16,19.43l3.03-.08"/>
                        <path class="building1 pathBuilding"
                              d="M89.58,240.85c0-11.93-6.02-19.36-16.77-19.36h-5.42c0,10.63,8.53,19.28,19.16,19.43l3.03-.08"/>
                    </g>
                    <path class="building1 pathBuilding"
                          d="M91.49,38.38c0-11.93-6.02-19.36-16.77-19.36h-5.42c0,10.63,8.53,19.28,19.16,19.43l3.03-.08"/>
                </g>
                <path class="building1 pathBuilding"
                      d="M25.59,285.71c0-5-1.68-9.82-4.72-13.78-2.92-3.82-8.17-7.08-13.13-7.08H1.88c0,11.5,9.23,20.86,20.73,21.02l2.98-.16"/>
                <path class="building1 pathBuilding"
                      d="M24.88,324.28v-3.61c-.19-13.56-10.31-24.46-23.88-24.46h0v6.92c0,12.12,11.75,21.95,23.88,21.95"/>
            </g>
            <path class="building1 pathBuilding"
                  d="M266.88,43.19l-.17,195.49c0,17.16,13.91,31.07,31.07,31.07h10.8c10.56,0,10.03-10.16,10.03-10.16,0-5.54-4.49-10.03-10.03-10.03h0c-5.54,0-10.03,4.49-10.03,10.03v28.61c0,17.27-14,31.28-31.28,31.28h-65.77c-19.05,0-34.49,15.44-34.49,34.49h0c0,19.05-15.44,34.49-34.49,34.49H44.31c-7.97,0-14.44,6.46-14.44,14.44v8.02c0,7.97,5.04,14.44,13.01,14.44h0"/>
            <path class="building1 pathBuilding"
                  d="M266.16,91.65c0-5-1.76-10.03-4.8-13.99-2.92-3.82-8.17-7.08-13.13-7.08h-5.86c0,11.5,9.23,20.86,20.73,21.02l3.06,.04"/>
            <path class="building1 pathBuilding"
                  d="M266.88,43.19c0-5-1.68-9.82-4.72-13.78-2.92-3.82-8.17-7.08-13.13-7.08h-5.86c0,11.5,9.23,20.86,20.73,21.02l2.98-.16"/>
            <path class="building1 pathBuilding"
                  d="M266.16,149c0-5-1.76-10.03-4.8-13.99-2.92-3.82-8.17-7.08-13.13-7.08h-5.86c0,11.5,9.23,20.86,20.73,21.02l3.06,.04"/>
            <path class="building1 pathBuilding"
                  d="M266.16,206.34c0-5-1.76-10.03-4.8-13.99-2.92-3.82-8.17-7.08-13.13-7.08h-5.86c0,11.5,9.23,20.86,20.73,21.02l3.06,.04"/>
            <path class="building1 pathBuilding"
                  d="M267.78,65.21c0-11.93,6.02-19.36,16.77-19.36h5.42c0,10.63-8.53,19.28-19.16,19.43l-3.03-.08"/>
            <path class="building1 pathBuilding"
                  d="M267.78,123.76c0-11.93,6.02-19.36,16.77-19.36h5.42c0,10.63-8.53,19.28-19.16,19.43l-3.03-.08"/>
            <path class="building1 pathBuilding"
                  d="M267.78,182.3c0-11.93,6.02-19.36,16.77-19.36h5.42c0,10.63-8.53,19.28-19.16,19.43l-3.03-.08"/>
            <path class="building1 pathBuilding"
                  d="M266.98,236.31c0-11.93,6.02-19.36,16.77-19.36h5.42c0,10.63-8.53,19.28-19.16,19.43l-3.03-.08"/>
            <path class="building1 pathBuilding"
                  d="M59.59,269.75h101.73c9.3,0,16.84-7.54,16.84-16.84h0c0-9.3-7.54-16.84-16.84-16.84h-2.41c-9.3,0-16.84,7.54-16.84,16.84h0c0,18.16,14.72,32.88,32.88,32.88h58.94c18.06,0,32.76-14.51,33-32.57v-18.23"/>
            <path class="building1 pathBuilding"
                  d="M240.41,318.66c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
            <path class="building1 pathBuilding"
                  d="M264.45,320.28c11.93,0,19.36,6.02,19.36,16.77v5.42h0c-10.63,0-19.28-8.53-19.43-19.16l.08-3.03"/>
            <path class="building1 pathBuilding"
                  d="M205.9,320.28c11.93,0,19.36,6.02,19.36,16.77v5.42h0c-10.63,0-19.28-8.53-19.43-19.16l.08-3.03"/>
            <path class="building1 pathBuilding"
                  d="M79.61,387.54c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
            <path class="building1 pathBuilding"
                  d="M125.72,387.54c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
            <path class="building1 pathBuilding"
                  d="M102.44,389.17c11.93,0,19.36,6.02,19.36,16.77v5.42h0c-10.63,0-19.28-8.53-19.43-19.16l.08-3.03"/>
            <path class="building1 pathBuilding"
                  d="M45.09,389.17c11.93,0,19.36,6.02,19.36,16.77v5.42h0c-10.63,0-19.28-8.53-19.43-19.16l.08-3.03"/>
            <path class="building1 pathBuilding"
                  d="M194.09,284.85c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
            <path class="building1 pathBuilding"
                  d="M105.06,269.61c5,0,10.03-1.76,13.99-4.8,3.82-2.92,7.08-8.17,7.08-13.13v-5.86c-11.5,0-20.86,9.23-21.02,20.73l-.04,3.06"/>
        </g>
    </g>
</svg>